import { Controller } from "stimulus"
import { Ajax } from "ajax"

export default class extends Controller {

  static targets = [ "count", "note", "button", "topic", "form" ]
  static values = { count: Number, url: String }

  countChanged() {
    let newCountValue = 0

    this.countTargets.forEach((el) => {
      newCountValue += Number(el.dataset.checkAllCountValue)
    })

    this.countValue = newCountValue
  }

  countValueChanged() {
    if (this.countValue < 5) {
      this.noteTargets.forEach((el) => {
        el.innerHTML = 'Bitte wähle mindestens 5 Kurse aus.'
        el.classList.remove('ok')
      })
      this.buttonTargets.forEach((el) => {
        el.disabled = true
        el.classList.add('disabled')
      })
    } else {
      this.noteTargets.forEach((el) => {
        el.innerHTML = `Sehr gut, du hast <b>${this.countValue} Kurse</b> gewählt.`
        el.classList.add('ok')
      })
      this.buttonTargets.forEach((el) => {
        el.disabled = false
        el.classList.remove('disabled')
      })
    }

  }

  submit() {
    // const data = new URLSearchParams();
    let form = this.formTargets[0]

    if (form) {
      this.topicTargets.forEach((el) => {
        if (el.classList.contains("checked")) {
          let input = document.createElement('input')
          input.type = "hidden"
          input.value = el.dataset.topicId
          
          if (el.dataset.dataType == 'topic') {
            input.name = "topic_ids[]"
          } else {
            input.name = "learning_field_ids[]"
          }

          form.appendChild(input)
        }
      })

      form.submit()
    }
  }
}